import { Sparkles } from 'lucide-react'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-luxury-white dark:bg-luxury-dark">
      <div className="flex flex-col items-center gap-4">
        <Sparkles className="w-10 h-10 text-luxury-champagne animate-pulse" />
        <p className="text-sm text-gray-500 dark:text-gray-400 animate-pulse">Loading...</p>
      </div>
    </div>
  )
}
